import { Link } from 'react-router-dom';

import { ROUTES } from '../../constants';

/** Trimmed raster lockups (no source SVG in repo — see public/brand/). */
export const BRAND_ASSETS = {
  lockup: {
    light: '/brand/strat-edu-lockup-light.png',
    dark: '/brand/strat-edu-lockup-dark.png',
  },
  mark: {
    light: '/brand/strat-edu-mark-light.png',
    dark: '/brand/strat-edu-mark-dark.png',
  },
} as const;

export type StratEduLogoAppearance = 'light' | 'dark';
export type StratEduLogoLayout = 'lockup' | 'mark';

type StratEduLogoProps = {
  layout?: StratEduLogoLayout;
  appearance?: StratEduLogoAppearance;
  /** @deprecated Use `layout="mark"` and `appearance`. */
  variant?: 'icon' | 'full';
  className?: string;
  linkToHome?: boolean;
};

const LOCKUP_HEIGHT = 'h-8 sm:h-9';
const MARK_SIZE = 'h-8 w-8 sm:h-9 sm:w-9';

function resolveLayout(props: StratEduLogoProps): StratEduLogoLayout {
  if (props.layout) {
    return props.layout;
  }
  if (props.variant === 'icon') {
    return 'mark';
  }
  return 'lockup';
}

function resolveAppearance(props: StratEduLogoProps): StratEduLogoAppearance {
  if (props.appearance) {
    return props.appearance;
  }
  return 'light';
}

export function StratEduLogo(props: StratEduLogoProps) {
  const {
    className = '',
    linkToHome = false,
  } = props;

  const layout = resolveLayout(props);
  const appearance = resolveAppearance(props);
  const src = BRAND_ASSETS[layout][appearance];
  const alt = layout === 'lockup' ? 'Strat-Edu' : 'Strat-Edu logo';

  const defaultSizeClass =
    layout === 'lockup'
      ? `${LOCKUP_HEIGHT} w-auto max-w-[min(11rem,52vw)] sm:max-w-none object-contain object-left`
      : `${MARK_SIZE} shrink-0 object-contain`;

  const img = (
    <img
      src={src}
      alt={alt}
      width={layout === 'lockup' ? 974 : 231}
      height={layout === 'lockup' ? 266 : 292}
      className={className.trim() || defaultSizeClass}
      decoding="async"
    />
  );

  if (linkToHome) {
    return (
      <Link
        to={ROUTES.HOME}
        className="inline-flex shrink-0 items-center leading-none"
      >
        {img}
      </Link>
    );
  }

  return img;
}
